// PRD.319 — PowerSync queries for Dental Investigations.
//
// Split from `dental-investigation-logic.ts` (types, selection) because that
// module must stay import-free to run under the node:test harness.

import type { QuerySpec } from '@helios/powersync-client-core';

export * from './dental-investigation-logic.js';

/**
 * Investigations for one encounter.
 *
 * Encounter-scoped, unlike the patient-longitudinal treatment plan: an
 * investigation documents what was taken at THIS visit.
 */
export function qDentalInvestigationsByEncounter(encounterId: string): QuerySpec<[string]> {
  return {
    key: ['dental_investigations', 'by-encounter', encounterId] as const,
    sql: `SELECT * FROM dental_investigations WHERE encounter_id = ?`,
    params: [encounterId],
    watch: ['dental_investigations'],
  };
}

/** Tooth scope for a patient's investigations, grouped client-side. */
export function qDentalInvestigationTeethByPatient(patientId: string): QuerySpec<[string]> {
  return {
    key: ['dental_investigation_teeth', 'by-patient', patientId] as const,
    sql: `SELECT * FROM dental_investigation_teeth WHERE patient_id = ?`,
    params: [patientId],
    watch: ['dental_investigation_teeth'],
  };
}
